import { memo, useMemo } from "react";
import Image from "next/image";
import { dot } from "../../components/dotlistStyle.js";
import { styles } from "../../utils/styles/careers-styles";
import Box from "@mui/material/Box";
import Title from "../../components/mini-components/Title.jsx";
import { colors } from "@/utils/const.js";
import { useI18n } from "@/i18n/I18nProvider";


const BENEFITS_IMG =
  "https://contact-eg.s3.us-east-2.amazonaws.com/general/benefits.webp";

function Benifits({ title, list = [], flag, type }) {
  const { locale } = useI18n();

  // margin on the side of the bullet direction
  const liSpacing = useMemo(() => (locale === "en" ? { mr: 5 } : { ml: 5 }), [
    locale,
  ]);

  // Avoid re-creating object per list item render
  const itemColor = flag ? colors.manhattan_blue : colors.navy_blue;
  const bgColor = flag ? colors.white : "#F8F8F8";
  const maxWidthLg = flag ? "100%" : "80%";

  return (
    <Box
      className="horizontal-safe-padding vertical-safe-padding"
      sx={{ bgcolor: bgColor }}
    >
      <Box
        sx={{
          ...styles.container,
          alignItems: "center",
          gap: { xs: 3, md: 5 }, // helps prevent reflow on wrapping
        }}
      >
        <Box sx={{ minWidth: 0, flex: "1 1 auto" }}>
          <Title title={title} />

          <Box
            component="ul"
            sx={{
              fontSize: "13px",
              ...dot.list,
              px: 2,
              m: 0,
            }}
          >
            {list.map((item, index) => {
              const key =
                type === "individual"
                  ? `${index}-${item?.pointTitle || "benefit"}`
                  : `${index}-${String(item)}`;

              return (
                <Box
                  key={key}
                  component="li"
                  sx={{
                    margin: "5px 0",
                    ...liSpacing,
                    fontSize: "16px",
                    fontWeight: "300",
                    color: itemColor,
                    pb: 1,
                    maxWidth: { lg: maxWidthLg },
                  }}
                >
                  {type === "individual" ? (
                    <>
                      <Box component="span" sx={{ fontWeight: 600 }}>
                        {item?.pointTitle}
                      </Box>
                      <Box component="span">{item?.pointDetails}</Box>
                    </>
                  ) : (
                    <Box component="span" sx={{ fontWeight: 600 }}>
                      {item}
                    </Box>
                  )}
                </Box>
              );
            })}
          </Box>
        </Box>

        {/* Image: reserve fixed box => zero CLS; Next/Image optimized loading */}
        <Box
          sx={{
            ...styles.img,
            width: { xs: "300px", md: "390px" },
            height: { xs: "300px", md: "390px" },
            margin: { xs: "auto", md: 0 },
            borderRadius: "16px",
            overflow: "hidden",
            position: "relative",
            flex: "0 0 auto",
          }}
        >
          <Image
            src={BENEFITS_IMG}
            alt="benefits"
            fill
            sizes="(max-width: 600px) 300px, 390px"
            style={{ objectFit: "cover" }}
            // Note: next/image handles lazy by default when not priority
            priority={false}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default memo(Benifits);
